module.exports = __webpack_public_path__ + "img/idea-vision-vision-icon.27afaa89.svg";